import { PrismicRichText } from "@prismicio/react";
import React from "react";
import Header from "./header";
import { colorCheck } from "../../utils/accessibility-helpers";
import { Link } from "gatsby";
import VideoModal from "../videoModal";
import MouseTrail from "../mouse-trail";

const HeaderNew = ({headCall, nav, heroTitle, hvec, video, vimeo, heroContent, heroCTA, videoText, home }) => {
  

  return (
    <div className="z-20 relative bg-gradient-to-b from-teal-lightest/20 to-white overflow-hidden">
      
    <Header nav={nav} headCall={headCall} home={home} />
    <section className="relative mb-16 md:mb-0" id="main">
      
        <div className="wrapper">
          
        <div className="flex flex-col top lg:flex-row items-center justify-center md:gap-0 lg:gap-24">
            <div className="hero w-full lg:w-1/2 md:mt-0 text-left py-8 md:py-16">
              <PrismicRichText field={heroTitle} />
              <PrismicRichText field={heroContent} />
                {heroCTA.map((btn, index) => {
                  if (btn.button_link == null) {
                    return "";
                  }
                  return (
                    <Link
                      key={index}
                      to={btn.button_link.url}
                      target={
                        btn.button_link.target === "_blank"
                          ? btn.button_link.target
                          : "_self"
                      }
                    >
                      <div className={"btn text-base mt-0 md:mt-4 bg-" + colorCheck(btn.button_color)}>
                        {btn.label.text}
                      </div>
                    </Link>
                  );
                })}
            </div>
            <div className="relative w-full md:w-1/2">
            <MouseTrail message={videoText} />
              <div className="hidden md:block">
                
                <VideoModal src={vimeo} title='Watch how we transform healthcare' />
                <video className="rounded-3xl" loop autoPlay muted preload="auto">
                  <source src={hvec} className="safari" type='video/mp4;codecs=hvc1' />
                  <source src={video} className="nosafari" type="video/webm" />
                </video>
              </div>
              <div className="video-wrapper block md:hidden border border-teal">
                <iframe
                  src={"https://player.vimeo.com/video/" + vimeo}
                  allow="autoplay; fullscreen; picture-in-picture"
                  title={videoText}
                />
              </div>
            </div>
          </div>
        
        </div>
      </section>
    </div>
    
  );
};

export default HeaderNew;
